import { LocalePlayer } from '../en/player'

const player: LocalePlayer = {
  searchPlayers: 'Tìm kiếm người chơi',
  playerProfile: 'Hồ Sơ Người Chơi',
  MALE: 'Nam',
  FEMALE: 'Nữ',
  signUpToSeeInfo: 'Đăng Ký Để Xem Thống Kê & Lịch Sử Trận Đấu Của Người Chơi',
  loginToSeeInfo: `Đăng nhập hoặc tạo một tài khoản nhằm xem kỷ lục thắng-thua của người dùng này, điểm số trung bình giành được, đối tác và đối thủ DUPR trung bình, tuổi thọ, lịch sử trận đấu và nhiều hơn nữa.`,
  profileUnlock: {
    title: 'Dùng lượt mở khóa?',
    subtitle: 'Dùng một lượt xem hồ sơ miễn phí của bạn',
    unlock: 'Mở khóa',
    limitReached: 'Đã đạt giới hạn',
    limitReachedSubtitle: 'Nâng cấp lên DUPR+ để xem hồ sơ không giới hạn',
    upgrade: 'Nâng cấp',
    upgradeLink: 'Nâng cấp để xem không giới hạn',
    viewsLeftShort_one: '{{count}} còn lại',
    viewsLeftShort_other: '{{count}} còn lại',
    infoTitle: 'Lượt xem hồ sơ miễn phí',
    info: 'Bạn có {{count}} lượt xem hồ sơ miễn phí.',
    resets: 'Đặt lại {{when}}.',
    banner: {
      viewsLeft_one: '{{count}} lượt xem còn lại',
      viewsLeft_other: '{{count}} lượt xem còn lại',
      runningLow: 'Bạn sắp hết lượt',
      freeViewsLeft_one: 'Còn {{count}} lượt xem hồ sơ miễn phí',
      freeViewsLeft_other: 'Còn {{count}} lượt xem hồ sơ miễn phí',
      unlockUnlimited: 'Mở khóa xem hồ sơ không giới hạn',
    },
  },
  filterRatingLocked: 'Nâng cấp lên DUPR+ để lọc theo trình độ',
  ratingLocked: 'Trình độ bị khóa',
}

export default player
